import { TranslationService } from "../../../services/TranslationService";

/** Notice shown where the agenda would be when the Agenda agent is not enabled. */
const AgendaUnavailable = () => (
  <p className="agenda-unavailable text-muted mb-0">
    {TranslationService.translate.AgendaNotAvailable}
  </p>
);

export default AgendaUnavailable;
